export default {
  stats: {
    year: 'Année',
    month: 'Mois',
    perYear: 'Par année',
    perMonth: 'Par mois',
    nbRooms: 'Nbr chambres',
    nbNights: 'Nbr jours',
    nbBookings: 'Nbr réservations',
    nbOvernights: 'Nbr nuitées',
    price: 'Dépense globale',
    noData: 'Aucune donnée',
    graph: 'Graphique'
  }
}
